export default {
  GET_QUESTIONS: "GET_QUESTIONS",
};
